import { cx } from '../cx.js';
import { LOGHI, type VarianteLogo } from '../logo/svg.generated.js';

export interface LogoProps {
  variant?: VarianteLogo;
  /** Altezza in px; la larghezza segue le proporzioni. Minimo 24px per il marchio, 120px di larghezza per l'orizzontale. */
  height?: number;
  className?: string;
  /** Se il logo è decorativo (es. accanto al nome già scritto), nasconde dai lettori di schermo. */
  decorative?: boolean;
}

/** Marchio Platea e logotipo dal brand kit, SVG inline (logotipo già in tracciati). */
export function Logo({ variant = 'orizzontale', height = 40, className, decorative = false }: LogoProps) {
  const { viewBox, body } = LOGHI[variant];
  return (
    <svg
      viewBox={viewBox}
      height={height}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : 'Aulaviva'}
      aria-hidden={decorative || undefined}
      className={cx('block w-auto', className)}
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
